<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp53',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-53">
    <module-title :title="moduleOption.title" margin-bottom="38" />
    <div class="comp-transverse-3 modules-id-53-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 3)"
        :key="`modules-id-53-item-${i}`"
        class="item"
        @click="onModuleItem(v)"
      >
        <el-image class="item-img" :src="v.photo | imgPath" fit="cover" />
        <p class="item-headline h-line-2">{{ v.headline }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-53-content {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 23px;
  .item {
    width: 360px;
    height: 109px;
    background: #fff;
    border: 2px solid #F89F12;
    box-shadow: 6px 8px 0px 0px rgba(215,116,121,0.09);
    border-radius: 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .item-img {
      width: 135px;
      height: 96px;
      border-radius: 5px;
    }
    .item-headline {
      width: 169px;
      font-size: 17px;
      font-family: siyuansong;
      font-weight: 800;
      color: #EC6818;
      margin-left: 10px;
    }
  }
}
</style>
